<template>
    <div class="view">
        <div class="header">
            <vxe-form ref="formRef" :data="queryform" @submit="submitEvent">
                <vxe-form-item title="助记词/名称" field="MnemonicPhrase" span="6" :item-render="{}">
                    <template #default="params">
                        <vxe-input v-model="queryform.MnemonicPhrase"></vxe-input>
                    </template>
                </vxe-form-item>
                
                <vxe-form-item align="center" span="6" :item-render="{}">
                    <template #default>
                        <vxe-button type="submit" status="primary" content="查询"></vxe-button>
                        <vxe-button status="primary" content="确定选择" @click="SureSelect"></vxe-button>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </div>
        <div class="content">
            <vxe-table :data="tableData" height="100%" max-height="100%" ref="tableRef" @radio-change="radioChangeEvent" :loading="loading"
                :row-config="{ isHover: true }" :radio-config="{ labelField: 'bh', highlight: true }">
                <vxe-column type="radio" field="bh" title="供货商编号" width="120"></vxe-column>
                <vxe-column field="gsmc" title="供货商名称" min-width="180" show-overflow></vxe-column>
                <vxe-column field="zjc" title="助记词" width="120"></vxe-column>
                <vxe-column field="lxr" title="联系人" width="100">
                    <template #default="{ row }">
                        {{ row.lxr || '-' }}
                    </template>
                </vxe-column>
                <vxe-column field="lxdh" title="联系电话" width="140">
                    <template #default="{ row }">
                        {{ row.lxdh && row.lxdh.trim() ? row.lxdh.trim() : '-' }}
                    </template>
                </vxe-column>
                <vxe-column field="ysk" title="应付款" width="130" align="right">
                    <template #default="{ row }">
                        <span :style="{ color: row.ysk > 0 ? '#F56C6C' : '#67C23A', fontWeight: 'bold' }">
                            {{ row.ysk ? row.ysk.toFixed(2) : '0.00' }}
                        </span>
                    </template>
                </vxe-column>
                <vxe-column field="se" title="税额" width="120" align="right">
                    <template #default="{ row }">
                        {{ row.se ? row.se.toFixed(2) : '0.00' }}
                    </template>
                </vxe-column>
                
            </vxe-table>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive, defineEmits, defineProps, onMounted } from 'vue'
import request from '@/request/request'
const selectRow = ref(null)
const queryform = reactive({ MnemonicPhrase: '', })
const tableData = ref([])
const loading = ref(false)
const emit = defineEmits(['select', 'cancel'])
// ✅ 正确：String 类型直接赋值
const props = defineProps({
    MnemonicPhraseProp: {
        type: String,
        default: ''  // 直接赋值
    }
})

const radioChangeEvent = ({ row }) => {
    selectRow.value = row
}
const submitEvent = async () => {
    await query()
}
const query = async () => {
    try { 
        loading.value = true
    if (queryform.MnemonicPhrase === '') {
        let res = await request.get('/Supplier/GetAllSupplier')
        tableData.value = res.data
    } else {
      let res = await request.get(`/Supplier/GetAllSupplier?keyword=${queryform.MnemonicPhrase}`)
      tableData.value = res.data
    }
    loading.value = false
    } catch (error) {
        loading.value = false
        alert(error)
    }
   
}
onMounted(async () => {
    queryform.MnemonicPhrase = props.MnemonicPhraseProp
    await query()
})
const tableRef = ref(null)
const SureSelect = () => {
    emit('select', selectRow.value)
}
</script>
<style scoped>
.view {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.content {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}
</style>